import React, { createContext, useContext, useEffect, useState } from "react";

const StateContext = createContext();

export const ContextProvider = ({ children }) => {
  const [currentPrimaryColor, setCurrentPrimaryColor] = useState("#041e42");
  const [currentSecondaryColor, setCurrentSecondaryColor] = useState("#041e42");
  const [currentTeritorryColor, setCurrentTerritoryColor] = useState("#041e42");
  const [currentBgImage, setCurrentBgImage]= useState("none")// side bar image background set
  const [currentOrientation, setCurrentOrientation] = useState("horizontal"); // orientation concept
  const [themeSettings, setThemeSettings] = useState(false);
  const [activeMenu, setActiveMenu] = useState(true);
  const [opensideBar, SetOpenSidebar] = useState("default")

  const handleColorPrimary = (color) => {
    setCurrentPrimaryColor(color);
    localStorage.setItem("colorModePrimary", color);
  };

  const handleSecondaryColor = (borderColor) => {
    setCurrentSecondaryColor(borderColor);
    localStorage.setItem("colorModeSecondary", borderColor);
  };

  const handleTerritoryColor = (borderColor) => {
    setCurrentTerritoryColor(borderColor);
    localStorage.setItem("colorModeTerritory", borderColor);
  };

  const setOrientation = (orientation) => {
    setCurrentOrientation(orientation);
    localStorage.setItem("orientation", orientation);
  };

  const handleCurrentImage = (currentImg) => {
    setCurrentBgImage(currentImg);
    localStorage.setItem("currentImg", currentImg);
  };

  const handlecurrentIconType = (type) =>{
    SetOpenSidebar(type);
    localStorage.setItem("currentIconType", type);
  }
  
  useEffect(() => {
    // Set the CSS variable for the dynamic color
    if(currentPrimaryColor) document.documentElement.style.setProperty('--current-primary-color', currentPrimaryColor);
    if(currentSecondaryColor) document.documentElement.style.setProperty('--current-secondary-color', currentSecondaryColor);
    if(currentTeritorryColor) document.documentElement.style.setProperty('--current-territory-color', currentTeritorryColor);
    if(opensideBar == null)  SetOpenSidebar('default');
    if(currentBgImage == null) setCurrentBgImage('none');
    if(currentOrientation == null || currentOrientation == undefined ) setCurrentOrientation("horizontal");
    if(currentPrimaryColor == null || currentPrimaryColor == undefined ) setCurrentPrimaryColor("#041e42");
    if(currentSecondaryColor == null || currentSecondaryColor == undefined ) setCurrentSecondaryColor("#041e42");
    if(currentTeritorryColor == null || currentTeritorryColor == undefined ) setCurrentTerritoryColor("#041e42");
  }, [currentSecondaryColor, currentTeritorryColor, currentPrimaryColor, opensideBar, currentBgImage, currentOrientation]);
  
  return (
    <StateContext.Provider
      value={{
        activeMenu,
        setActiveMenu,
        themeSettings,
        setThemeSettings,
        setOrientation,
        setCurrentOrientation,
        currentOrientation,
        // color base themes
        handleColorPrimary,
        handleSecondaryColor,
        handleTerritoryColor,
        currentPrimaryColor,
        currentSecondaryColor,
        currentTeritorryColor,
        setCurrentPrimaryColor,
        setCurrentSecondaryColor,
        setCurrentTerritoryColor,
        // image side set
        handleCurrentImage,
        setCurrentBgImage,
        currentBgImage,
        // icon side set
        handlecurrentIconType,
        SetOpenSidebar,
        opensideBar

      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
